export default __webpack_public_path__ + "static/media/smartbrain-project.5775dbaf.PNG";